import React, {Fragment, useState, useEffect} from "react";
import queryString from "query-string";
import ApprovalsTable from "root/Tables/ApprovalsTable";
import './ApprovalsTab.scss';
import useModalApprovePost from "root/Modals/ApprovePost/useModalApprovePost";
import {getContactMessages} from "root/DataFunctions/MessageDataFns";
import {getDataFromResponse} from "root/DataFunctions/BaseDataFns";
import {useLocation} from "react-router-dom";
import {MessageFilters, MessageType, MessageTypeFilters} from "root/DataFunctions/Constants";

const ApprovalsTab = (props) =>
{
    const [data, setData] = useState({loading: true, data: []});

    const [renderApprovalModal, showApprovalModal] = useModalApprovePost((result) =>
    {
        if (result === 'saved')
        {
            getData();
        }
    })

    const messageFilterDefault = MessageTypeFilters.MESSAGE_TYPE_ALL;
    const { search } = useLocation();
    const queryParams = queryString.parse(search) ;
    const messageFilter = queryParams.type === undefined?messageFilterDefault:queryParams.type;
    const filter = MessageFilters.NEW;

    useEffect(() => {
        getData(messageFilter);
    }, [messageFilter]);

    const getMyId = () =>
    {
        return phpVars.user_id;
    }

    const getData = (messageFilter) => {
        let messageType = null;

        switch (messageFilter){
            case MessageTypeFilters.MESSAGE_TYPE_ALL:
                messageType = MessageType.MESSAGE_TYPE_ALL;
                break;

            case MessageTypeFilters.MESSAGE_TYPE_LIFESTORY:
                messageType = MessageType.MESSAGE_TYPE_LIFESTORY;
                break;

            case MessageTypeFilters.MESSAGE_TYPE_MESSAGE:
                messageType = MessageType.MESSAGE_TYPE_MESSAGE;
                break;

            default:
                messageType = MessageType.MESSAGE_TYPE_ALL;
                break;
        }

        getContactMessages( getMyId(), null, filter, messageType, (response) =>
        {
            const data = getDataFromResponse( response ) ;
            setData({ isLoading: false, data: data});
        });
    }

    const clickHandler = (mode, child_uid, post_id, messageType, onDialogClosed ) =>
    {
        showApprovalModal(mode, child_uid, post_id, messageType, onDialogClosed);
    }

    return (
        <Fragment>
            <div className="family-body">
                <ApprovalsTable child_uid={props.child_uid} loading={data.loading} data={data.data} clickHandler={clickHandler}/>
            </div>

            {renderApprovalModal(props)}
        </Fragment>
    )
}

ApprovalsTab.defaultProps = {};

export default ApprovalsTab;

